import BlogCard from 'js/blog/components/Card'
import UserCard from 'js/components/userCard/UserCard'
import DiscussionCard from 'js/discussions/components/Card'
import EventCard from 'js/events/components/Card'
import ExternalContentCard from 'js/externalContent/ExternalContentCard'
import FileFolderCard from 'js/files/components/FileFolderCard'
import GenericArticleCard from 'js/genericArticle/Card'
import GroupCard from 'js/group/List/Card'
import StatusUpdateCard from 'js/group/StatusUpdate/Card'
import NewsCard from 'js/news/components/Card'
import PageCard from 'js/page/Card'
import EpisodeCard from 'js/podcast/components/EpisodeCard'
import PodcastCard from 'js/podcast/components/PodcastCard'
import QuestionCard from 'js/questions/components/Card'
import WikiCard from 'js/wiki/components/Card'

import RelatedSiteResultCard from './RelatedSiteResultCard'

type Entity = {
    __typename: string
    [key: string]: any
}

type Props = {
    entity: Entity
    tagCategories?: any[]
    [key: string]: any
}

const ActivityCard = ({ entity, ...rest }: Props) => {
    switch (entity.__typename) {
        case 'User':
            return <UserCard entity={entity} {...(rest as any)} />

        case 'Group':
            return (
                <GroupCard
                    entity={entity}
                    excerptMaxLines={3}
                    {...(rest as any)}
                />
            )

        case 'Page':
            return <PageCard entity={entity} {...(rest as any)} />

        case 'Wiki':
            return <WikiCard entity={entity} {...(rest as any)} />

        case 'News':
            return <NewsCard entity={entity} {...(rest as any)} />

        case 'Blog':
            return <BlogCard entity={entity} {...(rest as any)} />

        case 'Discussion':
            return <DiscussionCard entity={entity} {...(rest as any)} />

        case 'Event':
            return <EventCard entity={entity} {...(rest as any)} />

        case 'Question':
            return <QuestionCard entity={entity} {...(rest as any)} />

        case 'File':
        case 'Folder':
        case 'Pad':
            return <FileFolderCard entity={entity} {...(rest as any)} />

        case 'ExternalContent':
            return <ExternalContentCard entity={entity} {...(rest as any)} />

        case 'RelatedSiteSearchResult':
            return <RelatedSiteResultCard entity={entity} {...(rest as any)} />

        case 'Podcast':
            return <PodcastCard entity={entity} {...(rest as any)} />

        case 'Episode':
            return <EpisodeCard entity={entity} {...(rest as any)} />

        case 'GenericArticle':
            return <GenericArticleCard entity={entity} {...(rest as any)} />

        case 'StatusUpdate':
            return <StatusUpdateCard entity={entity} {...(rest as any)} />

        default:
            console.error('Unknown entity: ', entity)
            return null
    }
}

export default ActivityCard
